import { useSelector } from 'react-redux';

const useAuthSelector = () => useSelector((state: RootState) => state.auth);

export const useLoginStepSelector = () => useAuthSelector().currentStep;
export const useLoginSelector = () => useAuthSelector().login;
